import axios from 'axios';
import config from '../config';

export default (productId, siteId) => {
  const url = `${config.eleanorBaseUrl}/api/product/${productId}/site/${siteId}/pagemetaoverview`;
  return axios.get(url)
    .then((response) => response.data);
};
